import { render } from "./HousingSubsidy.vue?vue&type=template&id=466a579a&scoped=true"
import script from "./HousingSubsidy.vue?vue&type=script&lang=js"
export * from "./HousingSubsidy.vue?vue&type=script&lang=js"

import "./HousingSubsidy.vue?vue&type=style&index=0&id=466a579a&scoped=true&lang=less"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466a579a"]])

export default __exports__